import { FC } from 'react';

const ActionIconHeart: FC = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.26324 2.77578C2.94024 2.77578 2.61624 2.89878 2.37024 3.14378C2.13224 3.38178 2.00024 3.69878 2.00024 4.03478C2.00024 4.37078 2.13124 4.68678 2.36924 4.92378L5.99724 8.42778L9.64124 4.90978C9.86824 4.68378 10.0002 4.36878 10.0002 4.03178C10.0002 3.69578 9.86824 3.37978 9.63024 3.14078C9.13824 2.65078 8.33724 2.65078 7.84524 3.14078L5.99624 4.98778L4.15424 3.14278C3.90924 2.89878 3.58624 2.77578 3.26324 2.77578ZM5.99624 11.2058L0.967244 6.34478C0.340244 5.72078 0.000244141 4.90378 0.000244141 4.03478C0.000244141 3.16578 0.340244 2.34878 0.956244 1.73478C2.22724 0.466779 4.29724 0.464779 5.56924 1.73478L5.99824 2.16378L6.43024 1.73178C7.70324 0.462779 9.77224 0.462779 11.0442 1.73178C11.6602 2.34578 12.0002 3.16278 12.0002 4.03178C12.0002 4.90078 11.6602 5.71778 11.0442 6.33178L5.99624 11.2058Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { ActionIconHeart };
